import { create } from 'zustand'
import type { User } from '@yui-receipt/shared'
import { api, setToken } from '@/lib/api'

type AuthState = {
  user: User | null
  loading: boolean
  initialized: boolean
  init: () => Promise<void>
  login: (username: string, password: string) => Promise<void>
  logout: () => Promise<void>
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: false,
  initialized: false,
  async init() {
    set({ loading: true })
    try {
      const res = await api<{ user: User }>('/auth/me')
      set({ user: res.user })
    } catch {
      set({ user: null })
    } finally {
      set({ loading: false, initialized: true })
    }
  },
  async login(username, password) {
    set({ loading: true })
    try {
      const res = await api<{ token: string; user: User }>('/auth/login', {
        body: { username, password },
      })
      setToken(res.token)
      set({ user: res.user })
    } finally {
      set({ loading: false })
    }
  },
  async logout() {
    try {
      await api('/auth/logout', { method: 'POST' })
    } catch {
      // ignore
    }
    setToken(null)
    set({ user: null })
  },
}))
